export const mockData = {
  businessInfo: {
    name: "Lighthouse Insurance Agency",
    phone: "(954) 584-3417",
    email: "luis@lhinsur.com",
    address: "10242 NW 47th St Suite 10, Sunrise, FL 33331",
    hours: "Monday - Friday: 9 AM - 5 PM",
    rating: 4.9,
    reviewCount: 17
  },
  
  services: [
    {
      id: 1,
      title: "Personal Auto Insurance",
      description: "Comprehensive coverage for your vehicle with competitive rates and personalized service.",
      features: [
        "Liability Coverage",
        "Collision Coverage",
        "Comprehensive Coverage",
        "Personal Injury Protection",
        "Uninsured Motorist Coverage"
      ],
      icon: "Car"
    },
    {
      id: 2,
      title: "Commercial Auto Insurance",
      description: "Protect your business vehicles and fleet with tailored commercial auto insurance solutions.",
      features: [
        "Fleet Coverage",
        "Liability Protection",
        "Cargo Insurance",
        "Physical Damage Coverage",
        "Hired & Non-Owned Auto"
      ],
      icon: "Truck"
    },
    {
      id: 3,
      title: "Homeowners Insurance",
      description: "Safeguard your home and belongings with comprehensive homeowners insurance coverage.",
      features: [
        "Property Coverage",
        "Liability Protection",
        "Personal Property Coverage",
        "Additional Living Expenses",
        "Natural Disaster Protection"
      ],
      icon: "Home"
    }
  ],
  
  reviews: [
    {
      id: 1,
      author: "Lucy Molina",
      rating: 5,
      date: "2 months ago",
      text: "I had such a great experience with Lighthouse Insurance! From the start, Luis was incredibly helpful, professional, and knowledgeable. He really took the time to clearly explain my options, answered all of my questions, and made the entire process smooth and stress-free."
    },
    {
      id: 2,
      author: "High Voltage Volleyball Academy Coach Rocco",
      rating: 5,
      date: "2 weeks ago",
      text: "Great Service, fast response and Very knowledgable. Luis is the best 🙌 Thank you lighthouse insurance almost 10 years with you guys 🏆"
    },
    {
      id: 3,
      author: "Ryntox",
      rating: 5,
      date: "5 months ago",
      text: "I couldn't be happier with the service I received. From start to finish, the process was smooth, professional, and stress free. They took the time to explain all my options clearly, helped me find the perfect plan for my needs, and made sure I understood everything before moving forward."
    },
    {
      id: 4,
      author: "Juan Gomez",
      rating: 5,
      date: "5 months ago",
      text: "Luis was incredible!! I can barely spell insurance, but he took the time to explain everything to me and he was very knowledgeable! Most importantly, he was always available, which is very important to me. I highly recommend him!"
    },
    {
      id: 5,
      author: "Yesli Perez",
      rating: 5,
      date: "4 months ago",
      text: "Luis has been very helpful on anything I've needed regarding our insurance. He is a very nice and attentive person."
    },
    {
      id: 6,
      author: "Denisse Vides",
      rating: 5,
      date: "2 months ago",
      text: "Reliable, profesional, efficient and best rates!! Hands down the best agent I've worked with in a while. Do yourself a favor and sign up with Luis at lighthouse, trust me you won't regret it!!"
    },
    {
      id: 7,
      author: "Bassil Akel",
      rating: 5,
      date: "4 months ago",
      text: "Very competitive and trustworthy with their quotes and customer service. Luis is the best in the business. Thank you!"
    },
    {
      id: 8,
      author: "Britney Carver",
      rating: 5,
      date: "2 months ago",
      text: "I'm very impressed with the level of service and highly recommend Lighthouse Insurance to anyone looking for trustworthy and dependable coverage."
    },
    {
      id: 9,
      author: "Belen Alonso Daniel",
      rating: 5,
      date: "5 months ago",
      text: "The best insurance agency I ever worked with! Very professional and great customer service! I highly recommend it."
    },
    {
      id: 10,
      author: "Danay Gomez",
      rating: 5,
      date: "5 months ago",
      text: "I'm very happy with the customer service and insurance that Luis helped me with. He was extremely helpful and professional!!! Thank you 🙏🏻 Luis!!!"
    },
    {
      id: 11,
      author: "Lorena Hechavarria Rosales",
      rating: 5,
      date: "4 months ago",
      text: "Great experience, amazing customer service. All my needs were met and all my questions answered. 10/10 recommend!"
    },
    {
      id: 12,
      author: "Shedly Petit",
      rating: 5,
      date: "4 months ago",
      text: "Their services are outstanding, I have been with them for couple years now so far nothing to complain about."
    },
    {
      id: 13,
      author: "Fernando Doylet",
      rating: 5,
      date: "4 months ago",
      text: "Excellent service, always gets me the best rates. I appreciate your service."
    },
    {
      id: 14,
      author: "Lazaro Galindez",
      rating: 5,
      date: "5 months ago",
      text: "Great insurance call my cars are insured now thanks to light house and they are so professional and Great price."
    },
    {
      id: 15,
      author: "Tiffany Molina",
      rating: 5,
      date: "1 month ago",
      text: "Professional service with great rates on vehicle and commercial insurance."
    },
    {
      id: 16,
      author: "Samuel Delcid",
      rating: 5,
      date: "2 months ago",
      text: "Excellent experience with Lighthouse Insurance. Highly recommend!"
    },
    {
      id: 17,
      author: "Paola Barrera",
      rating: 5,
      date: "5 months ago",
      text: "Outstanding customer service and competitive rates."
    }
  ],
  
  whyChooseUs: [
    {
      title: "Expert Guidance",
      description: "Luis and our team provide knowledgeable, personalized insurance advice tailored to your needs."
    },
    {
      title: "Best Rates",
      description: "We work with multiple carriers to find you the most competitive rates without compromising coverage."
    },
    {
      title: "Always Available",
      description: "We're here when you need us with responsive service and quick answers to your questions."
    },
    {
      title: "Trusted Service",
      description: "With a 4.9-star rating and years of experience, our clients trust us to protect what matters most."
    }
  ],
  
  blogPosts: [
    {
      id: 1,
      title: "Understanding Auto Insurance Coverage in Florida",
      slug: "understanding-auto-insurance-coverage-florida",
      excerpt: "Florida has unique auto insurance requirements. Learn what coverage you need to stay protected and compliant on the road.",
      content: `
        <p>Florida's auto insurance landscape can be confusing for many drivers. Unlike most states, Florida operates under a no-fault insurance system, which means your insurance covers your injuries regardless of who caused the accident.</p>
        
        <h2>Required Coverage in Florida</h2>
        <p>Florida law requires all drivers to carry:</p>
        <ul>
          <li><strong>Personal Injury Protection (PIP):</strong> Minimum $10,000 coverage for medical expenses and lost wages</li>
          <li><strong>Property Damage Liability (PDL):</strong> Minimum $10,000 to cover damage to others' property</li>
        </ul>
        
        <h2>Recommended Additional Coverage</h2>
        <p>While not required, these coverages provide better protection:</p>
        <ul>
          <li><strong>Bodily Injury Liability:</strong> Protects you if you injure someone in an accident</li>
          <li><strong>Uninsured/Underinsured Motorist:</strong> Covers you if hit by a driver without adequate insurance</li>
          <li><strong>Comprehensive and Collision:</strong> Protects your own vehicle from damage</li>
        </ul>
        
        <h2>How Much Coverage Do You Need?</h2>
        <p>The minimum requirements often aren't enough. Consider your assets, income, and risk tolerance. Higher liability limits can protect your financial future in case of a serious accident.</p>
        
        <p>At Lighthouse Insurance, we help you understand your options and choose coverage that fits your needs and budget. Contact us today for a personalized quote.</p>
      `,
      category: "Auto Insurance",
      author: "Luis Garcia",
      date: "2025-01-15",
      readTime: "5 min read",
      image: null
    },
    {
      id: 2,
      title: "5 Ways to Lower Your Insurance Premiums",
      slug: "5-ways-lower-insurance-premiums",
      excerpt: "Discover practical strategies to reduce your insurance costs without sacrificing the coverage you need.",
      content: `
        <p>Insurance is essential, but it doesn't have to break the bank. Here are five proven strategies to lower your premiums while maintaining quality coverage.</p>
        
        <h2>1. Bundle Your Policies</h2>
        <p>Combining multiple insurance policies with the same provider typically results in significant discounts. Bundle your auto and home insurance to save 15-25% on average.</p>
        
        <h2>2. Increase Your Deductible</h2>
        <p>Raising your deductible from $500 to $1,000 can reduce your premium by 10-30%. Just make sure you have enough savings to cover the higher deductible if needed.</p>
        
        <h2>3. Maintain Good Credit</h2>
        <p>In Florida, insurers can use your credit score to determine rates. Maintaining good credit can significantly lower your premiums over time.</p>
        
        <h2>4. Ask About Discounts</h2>
        <p>Many discounts go unclaimed simply because people don't ask. Common discounts include:</p>
        <ul>
          <li>Safe driver discounts</li>
          <li>Good student discounts</li>
          <li>Low mileage discounts</li>
          <li>Safety feature discounts</li>
          <li>Professional association discounts</li>
        </ul>
        
        <h2>5. Review Your Coverage Annually</h2>
        <p>Your insurance needs change over time. Review your policies annually with your agent to ensure you're not over-insured or paying for coverage you no longer need.</p>
        
        <p>At Lighthouse Insurance, we specialize in finding you the best rates. Contact us for a free review of your current policies.</p>
      `,
      category: "Insurance Tips",
      author: "Luis Garcia",
      date: "2025-01-10",
      readTime: "4 min read",
      image: null
    },
    {
      id: 3,
      title: "Homeowners Insurance: What's Covered and What's Not",
      slug: "homeowners-insurance-coverage-guide",
      excerpt: "A comprehensive guide to understanding what your homeowners insurance covers and common exclusions you should know about.",
      content: `
        <p>Your home is likely your biggest investment, and homeowners insurance is designed to protect it. But many homeowners are surprised to learn what is and isn't covered under a standard policy.</p>
        
        <h2>What's Typically Covered</h2>
        <p>Standard homeowners insurance usually includes:</p>
        <ul>
          <li><strong>Dwelling Coverage:</strong> Repairs or rebuilding after covered damage</li>
          <li><strong>Personal Property:</strong> Your belongings inside the home</li>
          <li><strong>Liability Protection:</strong> Legal and medical costs if someone is injured on your property</li>
          <li><strong>Additional Living Expenses:</strong> Temporary housing if your home is uninhabitable</li>
          <li><strong>Other Structures:</strong> Detached garages, sheds, fences</li>
        </ul>
        
        <h2>Common Exclusions in Florida</h2>
        <p>Be aware that standard policies often exclude:</p>
        <ul>
          <li><strong>Flood Damage:</strong> Requires separate flood insurance</li>
          <li><strong>Hurricane Damage:</strong> May require special windstorm coverage</li>
          <li><strong>Sinkholes:</strong> Common in Florida, often needs added coverage</li>
          <li><strong>Mold:</strong> Usually limited or excluded</li>
          <li><strong>Wear and Tear:</strong> Normal maintenance isn't covered</li>
        </ul>
        
        <h2>Special Considerations for Florida Homeowners</h2>
        <p>Florida's unique climate and geography require special attention:</p>
        <ul>
          <li>Hurricane deductibles are often separate and higher</li>
          <li>Roof age can affect coverage and costs significantly</li>
          <li>Windstorm coverage may be required by your lender</li>
        </ul>
        
        <p>Understanding your homeowners insurance is crucial. Let Lighthouse Insurance review your policy and ensure you have the right protection for your Florida home.</p>
      `,
      category: "Homeowners Insurance",
      author: "Luis Garcia",
      date: "2025-01-05",
      readTime: "6 min read",
      image: null
    },
    {
      id: 4,
      title: "Commercial Auto Insurance for Small Businesses",
      slug: "commercial-auto-insurance-small-business",
      excerpt: "Learn why commercial auto insurance is essential for your business and what coverage options are available.",
      content: `
        <p>If you use vehicles for business purposes, you need commercial auto insurance. Personal auto policies typically don't cover business use, leaving you vulnerable to significant financial risk.</p>
        
        <h2>When Do You Need Commercial Auto Insurance?</h2>
        <p>You need commercial coverage if:</p>
        <ul>
          <li>Vehicles are owned by your business</li>
          <li>You transport goods or materials for business</li>
          <li>You regularly transport clients or customers</li>
          <li>Employees drive company vehicles</li>
          <li>You use your personal vehicle primarily for business</li>
        </ul>
        
        <h2>Types of Commercial Auto Coverage</h2>
        <p><strong>Liability Coverage:</strong> Protects against injuries and property damage you cause to others.</p>
        <p><strong>Physical Damage Coverage:</strong> Covers damage to your business vehicles from collisions, theft, vandalism, or weather.</p>
        <p><strong>Uninsured Motorist Coverage:</strong> Protects you if hit by a driver without insurance.</p>
        <p><strong>Medical Payments Coverage:</strong> Pays medical expenses for you and your passengers.</p>
        <p><strong>Hired and Non-Owned Auto:</strong> Covers vehicles your business doesn't own but uses.</p>
        
        <h2>How Much Does It Cost?</h2>
        <p>Costs vary based on:</p>
        <ul>
          <li>Type and number of vehicles</li>
          <li>How vehicles are used</li>
          <li>Driver records</li>
          <li>Coverage limits chosen</li>
          <li>Business location</li>
        </ul>
        
        <h2>Protecting Your Business</h2>
        <p>The right commercial auto insurance protects your business assets, employees, and financial future. Don't risk operating without proper coverage.</p>
        
        <p>Lighthouse Insurance specializes in commercial auto coverage for small businesses in Florida. Get a customized quote today.</p>
      `,
      category: "Commercial Insurance",
      author: "Luis Garcia",
      date: "2024-12-28",
      readTime: "5 min read",
      image: null
    },
    {
      id: 5,
      title: "What to Do After a Car Accident in Florida",
      slug: "what-to-do-after-car-accident-florida",
      excerpt: "A step-by-step guide on what to do immediately after a car accident to protect yourself and ensure a smooth claims process.",
      content: `
        <p>Being in a car accident is stressful, but knowing what to do can protect you legally and financially. Follow these steps if you're involved in an accident in Florida.</p>
        
        <h2>Immediate Steps at the Scene</h2>
        <ol>
          <li><strong>Check for Injuries:</strong> Ensure everyone is safe. Call 911 if anyone is hurt.</li>
          <li><strong>Move to Safety:</strong> If possible, move vehicles to the side of the road to prevent further accidents.</li>
          <li><strong>Call the Police:</strong> File a police report, especially if there are injuries or significant damage.</li>
          <li><strong>Exchange Information:</strong> Get names, phone numbers, addresses, driver's license numbers, license plate numbers, and insurance information.</li>
          <li><strong>Document Everything:</strong> Take photos of vehicle damage, the accident scene, road conditions, and any visible injuries.</li>
          <li><strong>Get Witness Information:</strong> Collect names and contact information from any witnesses.</li>
        </ol>
        
        <h2>Within 24 Hours</h2>
        <ul>
          <li><strong>Notify Your Insurance Company:</strong> Report the accident promptly, even if you weren't at fault.</li>
          <li><strong>Seek Medical Attention:</strong> See a doctor even if you feel fine. Some injuries don't show symptoms immediately, and Florida's PIP requires medical treatment within 14 days.</li>
          <li><strong>Keep Records:</strong> Save all documents, medical bills, and repair estimates.</li>
        </ul>
        
        <h2>What NOT to Do</h2>
        <ul>
          <li>Don't admit fault at the scene</li>
          <li>Don't sign anything except police reports</li>
          <li>Don't accept quick settlement offers without consulting your agent</li>
          <li>Don't post about the accident on social media</li>
        </ul>
        
        <h2>Understanding Florida's No-Fault System</h2>
        <p>Florida is a no-fault state, meaning your own insurance (PIP) covers your medical bills regardless of who caused the accident. However, you can still sue for damages in serious injury cases.</p>
        
        <p>Need help with an insurance claim? Contact Lighthouse Insurance for expert guidance through the claims process.</p>
      `,
      category: "Insurance Claims",
      author: "Luis Garcia",
      date: "2024-12-20",
      readTime: "7 min read",
      image: null
    },
    {
      id: 6,
      title: "Insurance Shopping: Questions to Ask Your Agent",
      slug: "insurance-shopping-questions-to-ask",
      excerpt: "Make informed decisions by asking these essential questions when shopping for insurance coverage.",
      content: `
        <p>Shopping for insurance can be overwhelming with so many options and terms. Asking the right questions helps you make informed decisions and get the coverage you need.</p>
        
        <h2>Coverage Questions</h2>
        <ul>
          <li><strong>"What does this policy cover and not cover?"</strong> - Understand the specifics, not just the highlights.</li>
          <li><strong>"What are my deductibles?"</strong> - Know what you'll pay out of pocket before insurance kicks in.</li>
          <li><strong>"What are my coverage limits?"</strong> - Ensure limits are adequate for your assets and risk exposure.</li>
          <li><strong>"Are there any sub-limits I should know about?"</strong> - Some items like jewelry may have lower limits.</li>
        </ul>
        
        <h2>Cost and Savings Questions</h2>
        <ul>
          <li><strong>"What discounts am I eligible for?"</strong> - Don't leave money on the table.</li>
          <li><strong>"How can I lower my premium?"</strong> - Get specific suggestions beyond raising deductibles.</li>
          <li><strong>"Will bundling policies save me money?"</strong> - Often the best discount available.</li>
          <li><strong>"How often do you review rates?"</strong> - Ensure you're getting competitive pricing.</li>
        </ul>
        
        <h2>Claims Process Questions</h2>
        <ul>
          <li><strong>"What's your claims process?"</strong> - Know what to expect when you need to file.</li>
          <li><strong>"How quickly are claims typically processed?"</strong> - Important when you need quick resolution.</li>
          <li><strong>"Will you help me through the claims process?"</strong> - Agent support can be invaluable.</li>
          <li><strong>"Will filing a claim increase my rates?"</strong> - Understand the potential impact.</li>
        </ul>
        
        <h2>Company and Agent Questions</h2>
        <ul>
          <li><strong>"How long have you been in business?"</strong> - Experience matters.</li>
          <li><strong>"Are you available after hours?"</strong> - Emergencies don't wait for business hours.</li>
          <li><strong>"Do you work with multiple carriers?"</strong> - More options mean better rates and coverage.</li>
          <li><strong>"Can you provide references?"</strong> - Past clients can share their experience.</li>
        </ul>
        
        <h2>Policy Management Questions</h2>
        <ul>
          <li><strong>"How do I make changes to my policy?"</strong> - Know the process for updates.</li>
          <li><strong>"When should I review my coverage?"</strong> - Life changes require coverage adjustments.</li>
          <li><strong>"What happens if I miss a payment?"</strong> - Understand grace periods and consequences.</li>
        </ul>
        
        <p>At Lighthouse Insurance, we welcome your questions and take the time to ensure you fully understand your coverage options. We're here to educate, not just sell.</p>
        
        <p>Ready to have a conversation about your insurance needs? Contact us today for honest, expert guidance.</p>
      `,
      category: "Insurance Tips",
      author: "Luis Garcia",
      date: "2024-12-15",
      readTime: "6 min read",
      image: null
    }
  ]
};
